import BaseComponent from '../abstracts/BaseComponent';

export default class ChangeLanguageComponent extends BaseComponent {
  constructor(element) {
    super(element);

    this.closeDropdown();
    this.bindChange();

    this.updateAnchors();
  }

  closeDropdown() {
    this.$on('click.cl', (e) => {
      this.EMIT(this.CUSTOM_MESSAGES.DROPDOWN_EVENTS.hide);
    });
  }

  bindChange() {
    this.$on('change.cl', (e) => {
      const value = e.currentTarget.value;
      window.location.assign(value);
    });
  }

  updateAnchors() {
    const anchors = this.$el.closest('.dropdown-panel').querySelectorAll('a');
    anchors.forEach(function(anchor) {
      const href = anchor.getAttribute('href');
      const lang = href && (href.length > 1) && href.substr(1);
      const link = lang && document.querySelector(`link[rel="alternate"][hreflang="${lang}"]`);
      link && link.href && (anchor.href = link.href);
    });
  }
}
